import { useState, useCallback } from "react";

const MAX_RECENT = 5;

/**
 * In-memory recent searches. Persists across search sheet open/close
 * within the same app session.
 */
const stored: string[] = [];

export function useRecentSearches() {
  const [recents, setRecents] = useState<string[]>(stored);

  const addRecent = useCallback((query: string) => {
    const trimmed = query.trim();
    if (!trimmed || trimmed.length < 2) return;

    const idx = stored.indexOf(trimmed);
    if (idx !== -1) stored.splice(idx, 1);
    stored.unshift(trimmed);
    if (stored.length > MAX_RECENT) stored.pop();
    setRecents([...stored]);
  }, []);

  const clearRecents = useCallback(() => {
    stored.length = 0;
    setRecents([]);
  }, []);

  return { recents, addRecent, clearRecents };
}
